import { createAsyncThunk } from "@reduxjs/toolkit";
import { cloudChiprApi, CommitmentType } from "@/services/cloudchipr.api";

export const getRecommendationFiltersPreferenceKey = (type: CommitmentType) =>
  `c8r:CommitmentRecommendations_filters_${type}`;

export const getRecommendationFiltersUserPreferenceByKeyThunk =
  createAsyncThunk(
    "recommendations/getRecommendationFiltersUserPreferenceByKey",
    async (type: CommitmentType, { dispatch }) => {
      const { getUsersMeCurrentPreferenceByKey } = cloudChiprApi.endpoints;

      await dispatch(
        getUsersMeCurrentPreferenceByKey.initiate(
          {
            key: getRecommendationFiltersPreferenceKey(type),
          },
          { forceRefetch: true },
        ),
      );
    },
  );
